import { gql } from "@apollo/client"

import { useMutation, InjectedOptions } from "@oysterhr/core"
import { ProvisionPackageInput, ProvisionPackagePayload } from "@oysterhr/schema"
import { PLAN_CONTRIBUTION_SETTINGS_FRAGMENT } from "~/shared/fragments/PlanContributionSettingFragment"

const PROVISION_PACKAGE_MUTATION = gql`
  ${PLAN_CONTRIBUTION_SETTINGS_FRAGMENT}
  mutation ProvisionPackage(
    $engagementId: ID!
    $tierId: ID
    $addonIds: [ID!]
    $benefitsDescription: String
    $pensions: [BenefitsEnrollmentPensionInput!]
    $plansCostContribution: [BenefitsEnrollmentCostContributionInput!]
  ) {
    provisionPackage(
      input: {
        engagementId: $engagementId
        tierId: $tierId
        addonIds: $addonIds
        benefitsDescription: $benefitsDescription
        pensions: $pensions
        plansCostContribution: $plansCostContribution
      }
    ) {
      errors
      engagement {
        id
        benefitsEnrolledPackages {
          collection {
            tier {
              id
            }
          }
        }
        benefitsProvisionedEnrollments {
          collection {
            plan {
              id
              name
              category
              costSplitAllowed
              provider {
                id
                name
              }
              ...PlanContributionSettingFragment
            }
            enrollmentCostContributions {
              collection {
                contributor
                amountAsPercentage
              }
            }
          }
        }
      }
    }
  }
`

export type _ProvisionPackagePayload = { provisionPackage: ProvisionPackagePayload }

export const useProvisionPackage = (
  options?: InjectedOptions<_ProvisionPackagePayload, ProvisionPackageInput>,
) => {
  return useMutation<_ProvisionPackagePayload, ProvisionPackageInput>(
    PROVISION_PACKAGE_MUTATION,
    options,
  )
}
